module.exports = __webpack_public_path__ + "img/upload-failed.04c1c46a.svg";